import type HttpClient from "../../tastyworks/http"
import {
  parseItemsResponse,
  parseSingleResponse,
  type ItemsResponse,
  type SingleResponse,
} from "../../tastyworks/response"
import { Watchlist, WATCHLIST_DESER } from "../../tastyworks/watchlist"

export class WatchlistService {
  private readonly httpClient: HttpClient

  constructor(baseHttpClient: HttpClient) {
    this.httpClient = baseHttpClient
  }

  readonly getPublicWatchlists = async (
    includeForex?: boolean
  ): Promise<ItemsResponse<Watchlist>> => {
    const helper = await this.httpClient.get("/public-watchlists", {
      "include-forex": includeForex,
    })

    return parseItemsResponse(helper, WATCHLIST_DESER.toParser(Watchlist))
  }

  readonly getPublicWatchlistByName = async (
    name: string
  ): Promise<SingleResponse<Watchlist>> => {
    const helper = await this.httpClient.get("/public-watchlists/:name", {
      name,
    })

    return parseSingleResponse(helper, WATCHLIST_DESER.toParser(Watchlist))
  }
}
